import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"url(#info_svg__a)\" d=\"M0 8a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v32a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"></path><path fill=\"currentColor\" d=\"M24 14c5.52 0 10 4.48 10 10s-4.48 10-10 10-10-4.48-10-10 4.48-10 10-10m0 9c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1m-1-2h2v-2h-2z\"></path><defs><linearGradient id=\"info_svg__a\" x1=\"0\" x2=\"48\" y1=\"0\" y2=\"48\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#9087A1\" stop-opacity=\".64\"></stop><stop offset=\"1\" stop-color=\"#9087A1\" stop-opacity=\".08\"></stop></linearGradient></defs>", 3)
  ]))]))
}
export default { render: render }